module.exports = __webpack_public_path__ + "static/Features_Glass-54f16f8059eac26511f6372c67eb3963.png";